import { supabase } from './supabase-client';
/**
 * Shared fetch/toggle used by the reference library and al studios.
 * Both features store per-user bookmarks the same way: (user_id, key).
 */
export async function fetchUserBookmarkKeys(opts) {
    const { data, error } = await supabase
        .from(opts.table)
        .select(opts.keyColumn)
        .eq('user_id', opts.userId)
        .order('created_at', { ascending: false });
    if (error)
        throw new Error(error.message);
    return (data ?? []).map((row) => row[opts.keyColumn]);
}
export async function toggleUserBookmark(opts) {
    if (opts.currentlyBookmarked) {
        const { error } = await supabase
            .from(opts.table)
            .delete()
            .eq('user_id', opts.userId)
            .eq(opts.keyColumn, opts.key);
        if (error)
            throw new Error(error.message);
        return { key: opts.key, bookmarked: false };
    }
    const { error } = await supabase.from(opts.table).insert([
        { user_id: opts.userId, [opts.keyColumn]: opts.key },
    ]);
    if (error)
        throw new Error(error.message);
    return { key: opts.key, bookmarked: true };
}
